import { type IntlShape, useIntl } from 'react-intl';

import type { MessageKey } from '../../../../configuration';
import { PriceInfoDaily } from '../../common/price/PriceInfoDaily';
import { PriceInfoLongTerm } from '../../common/price/PriceInfoLongTerm';
import { OverlayTrigger, Tooltip } from '../../common/utils/tooltipReExports';
import { DEFAULT_TOOLTIP_DELAY } from '../../config/config';
import { isBookableProduct, type Product } from '../redux/types';

const renderEstimatedPriceInfo = (intl: IntlShape, messageKey: MessageKey) => (
    <OverlayTrigger
        trigger={OverlayTrigger.TRIGGER_HOVER}
        placement='bottom'
        overlay={
            <Tooltip id='tooltip' className={'width-auto max-width-300'}>
                {intl.formatMessage({ id: messageKey })}
            </Tooltip>
        }
        delay={DEFAULT_TOOLTIP_DELAY}
    >
        <span className='PriceDetails-estimated-info-icon uikit-icon icon-info-sign' />
    </OverlayTrigger>
);

interface Props {
    selectedProduct: Product;
}

export const PriceDetails = (props: Props) => {
    const { selectedProduct } = props;
    const bookableProduct = isBookableProduct(selectedProduct) ? selectedProduct : undefined;

    const price = bookableProduct?.price;
    const currency = bookableProduct?.currency;
    const productType = bookableProduct?.productType;

    const intl = useIntl();

    if (price === 0 || price === undefined) {
        return null;
    }
    return (
        <div className='text-right text-size-12'>
            <PriceInfoDaily price={price} currency={currency} productType={productType} />
            <span className={'uikit-icon icon-triangle-right'} />
            <PriceInfoLongTerm price={price} currency={currency} productType={productType} />{' '}
            {renderEstimatedPriceInfo(intl, 'intl-msg:marketplace.productDetails.price.estimated.explanation')}
        </div>
    );
};

export const PriceDetailsContainer = PriceDetails;
